import { Injectable } from '@angular/core';
import { db, Tabla } from './db';

@Injectable({
  providedIn: 'root'
})
export class StorageService {



  constructor() {
    console.log('StorageService constructor');
    this.initBD();
    var terceros = {
      id: 'TERCEROS_BOCCHERINI2',
      prefijo: 'BOCCHE',
      empresa: 'BOCCHERINI',
      tabla: 'TERCEROS',
      registros: [{}]
    }
    this.addReg('Tablas', terceros)
    this.getReg('Tablas', 'id', 'TERCEROS_BOCCHERINI2', {})
    this.validateTable('Tablas', {})
  }


  initBD() {
    db.open()                             //opening the database
      .then(data => console.log("DB Opened"))
      .catch(err => console.log(err.message));
  }

  addReg(store: string, tabla: any): void {
    db.table(store)
      .add(tabla)
      .then(data => console.log(data))
      .catch(err => { console.log(err.message) });
  }

  deleteReg(store: string, key: any): void {
    db.table(store)
      .delete(key)
      .then(data => console.log(data))
      .catch(err => { console.log(err.message) });
  }

  updatedReg(store: string, key: any, tabla:any): void {
    db.table(store)
      .put(tabla,key)
      .then(data => console.log(data))
      .catch(err => { console.log(err.message) });
  }

  getReg(store, where, equals, tabla){
    // db.table(store).where(where).equals(equals).toArray().then(data => {
    //   console.log('respuesta consulta dexie', data);
    // })
    return db.table(store).where(where).equals(equals).toArray()
  }

  validateTable(store, tabla){
    db.table(store).each(res=>{
      // console.log('respuesta each dexie', res);
    })
  }

}
